<button mat-raised-button color="primary" (click)="openBio()" type="button" *ngIf="(showButton$ | async)">User's Bio</button>
